import { CSSProperties, ReactNode } from "react";
import { ITooltip, Tooltip as ReactTooltip } from "react-tooltip";
import { Css } from "~generated/css";
import { useTestIds } from "~utils";

export type TooltipV2Props = {
  children: ReactNode;
  title?: ReactNode;
  /** Defaults to "max-content". */
  width?: string;
  /** Note: Depending on use case for override, it may be better to update the default styling and start using type variants
   *
   * https://react-tooltip.com/docs/examples/styling#explanation
   * */
  cssOverrides?: CSSProperties;
} & Pick<
  ITooltip,
  "clickable" | "positionStrategy" | "anchorSelect" | "noArrow" | "openOnClick" | "place" | "offset" | "hidden"
>;

// TODO: We'll implement this as v2 while we do configurator work and deprecate the rest as we go
//  - Button.tsx
//  - LocationSection.tsx
//  - IconButton.tsx

/** Note: Most cutoff problems caused by overflow hidden can be fixed by adding a `positionStrategy: fixed`.
 * In this case you need to guarantee `anchorSelect` is unique to prevent multiple tooltips from rendering stacked.
 * */
export function TooltipV2(props: TooltipV2Props) {
  const { children, width = "max-content", title, cssOverrides = {}, ...others } = props;

  const tid = useTestIds(props, "tooltipV2");

  return (
    <ReactTooltip
      style={{
        // default react-tooltip style overrides
        ...Css.fs("100%").p2.br0.w(width).maxwPx(224).$,
        // HB
        ...Css.z999.$,
        ...cssOverrides,
      }}
      opacity={1}
      noArrow={true}
      {...others}
      {...tid}
    >
      <div css={Css.df.gap1.t10.white.lhPx(22).tal.if(!!title).fdc.gap1.else.aic.$}>
        {title && title}
        {children}
      </div>
    </ReactTooltip>
  );
}
